import classNames from 'classnames';
import { DateTime } from 'luxon';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
  inStock: {
    id: 'productMatrix.storageInStock',
    defaultMessage: 'In stock',
  },
  incoming: {
    id: 'productMatrix.storageIncoming',
    defaultMessage: 'Incoming:',
  },
  unknownDate: {
    id: 'productMatrix.storageIncomingUnknownDate',
    defaultMessage: 'unknown',
  },
});

const formatIncomingDate = (incomingQuantity) => {
  if (!incomingQuantity?.date) {
    return null;
  }

  return DateTime.fromISO(incomingQuantity.date).toLocaleString() || null;
};

const getIncomingQuantity = (incomingQuantity) => {
  if (incomingQuantity.free_quantity != null) {
    return incomingQuantity.free_quantity;
  }

  if (incomingQuantity.quantity != null) {
    return incomingQuantity.quantity;
  }

  return 0;
};

const ProductCollectionMatrixStorageStockLines = ({
  storage,
  stockUnit,
  isLeftAligned,
}) => {
  const incomingQuantities = storage.incoming_quantities || [];

  return (
    <div
      className={classNames('ProductCollectionMatrixStorageStockLines', {
        'ProductCollectionMatrixStorageStockLines--left-aligned': isLeftAligned,
      })}
    >
      <div className="ProductCollectionMatrixStorageStockLines__group ProductCollectionMatrixStorageStockLines__group--in-stock">
        <div className="ProductCollectionMatrixStorageStockLines__line">
          <span className="ProductCollectionMatrixStorageStockLines__quantity">
            {storage.in_stock_quantity} {stockUnit}
          </span>{' '}
          <span className="ProductCollectionMatrixStorageStockLines__label">
            <FormattedMessage {...messages.inStock} />
          </span>
        </div>
      </div>
      {incomingQuantities.length > 0 && (
        <div className="ProductCollectionMatrixStorageStockLines__group ProductCollectionMatrixStorageStockLines__group--incoming">
          <div className="ProductCollectionMatrixStorageStockLines__heading">
            <FormattedMessage {...messages.incoming} />
          </div>
          {incomingQuantities.map((incomingQuantity, index) => {
            const quantity = getIncomingQuantity(incomingQuantity);
            const date = formatIncomingDate(incomingQuantity) || (
              <FormattedMessage {...messages.unknownDate} />
            );

            return (
              <div
                key={`${
                  incomingQuantity.date || 'no-date'
                }-${quantity}-${index}`}
                className="ProductCollectionMatrixStorageStockLines__quantity"
              >
                {quantity} {stockUnit} ({date})
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

ProductCollectionMatrixStorageStockLines.propTypes = {
  storage: PropTypes.shape({
    in_stock_quantity: PropTypes.number,
    incoming_quantities: PropTypes.array,
  }).isRequired,
  stockUnit: PropTypes.string,
  isLeftAligned: PropTypes.bool,
};

export default observer(ProductCollectionMatrixStorageStockLines);
